import Vue from 'vue'
import Router from 'vue-router'
import workbench from './views/workbench/index.vue'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: '工作台',
            props:{index:1},
            component: workbench
        },
        {
            path: '/business',
            name: '业务管理',
            props:{index:2},
            component: () => import('./views/business/index.vue'),
            children:[
                {
                    path: '/business/monitor',
                    name: '客服监控',
                    props:{index:1},
                    component: () => import('./views/business/monitor/monitor.vue'),
                    children:[
                        {
                            path: '/business/monitor/team',
                            name: '客服团队',
                            props:{index:"1-1"},
                            component: () => import('./views/business/monitor/team.vue'),
                        },
                        {
                            path: '/business/monitor/rateLog',
                            name: '评价记录',
                            props:{index:"1-2"},
                            component: () => import('./views/business/monitor/rateLog.vue'),
                        },
                    ]
                },
                {
                    path: '/business/customerLog',
                    name: '客户记录',
                    props:{index:2},
                    component: () => import('./views/business/customerLog/customerLog.vue'),
                    children:[
                        {
                            path: '/business/customerLog/company',
                            name: '企业',
                            props:{index:"1-1"},
                            component: () => import('./views/business/customerLog/company.vue'),
                        },
                        {
                            path: '/business/customerLog/carOwn',
                            name: '车主',
                            props:{index:"1-2"},
                            component: () => import('./views/business/customerLog/carOwn.vue'),
                        },
                    ]
                },
                {
                    path: '/business/inquire',
                    name: '询价管理',
                    props:{index:3},
                    component: () => import('./views/business/inquire/inquire.vue'),
                    children:[
                        {
                            path: '/business/inquire/bj',
                            name: 'bj',
                            props:{index:"1-2"},
                            component: () => import('./views/business/inquire/bj.vue'),
                        },
                        {
                            path: '/business/inquire/xj',
                            name: '询价单',
                            props:{index:"1-1"},
                            component: () => import('./views/business/inquire/xj.vue'),
                        },
                        {
                            path: '/business/inquire/order',
                            name: '订单',
                            props:{index:"1-2"},
                            component: () => import('./views/business/inquire/order.vue'),
                        },
                        {
                            path: '/business/inquire/customerInquires',
                            name: '客户询价单',
                            props:{index:"1-3"},
                            component: () => import('./views/business/inquire/customerInquires.vue'),
                        },
                        {
                            path: '/business/inquire/inquiryBillsList',
                            name: '易询宝询价单',
                            props:{index:"1-4"},
                            component: () => import('./views/business/yxbInquiry/inquiryBillsList.vue'),
                        },
                         {
                            path: '/business/inquire/inquiryDeatil',
                            name: '易询宝询价单详情',
                            props:{index:"1-4"},
                            component: () => import('./views/business/yxbInquiry/inquiryDetail.vue'),
                        },
                    ]
                },
                {
                    path: '/business/search',
                    name: '汽配快搜',
                    props:{index:4},
                    component: () => import('./views/business/search/search.vue'),
                    children:[
                        {
                            path: '/business/search/goodSearch',
                            name: '搜汽配',
                            props:{index:"1-2"},
                            component: () => import('./views/business/search/goodSearch.vue'),
                        },
                        {
                            path: '/business/search/qpSearch',
                            name: '搜商品',
                            props:{index:"1-1"},
                            component: () => import('./views/business/search/qpSearch.vue'),
                        },
                        {
                            path: '/business/search/supplieSearch',
                            name: '搜索商城商品',
                            props:{index:"1-3"},
                            component: () => import('./views/business/search/supplieSearch.vue'),
                        },
                        {
                            path: '/business/search/goodsDetail',
                            name: '搜索商城商品',
                            props:{index:"1-3"},
                            component: () => import('./views/business/search/goodsDetail.vue'),
                        },
                    ]
                },
                {
                    path: '/business/dataCount',
                    name: '数据统计',
                    props:{index:5},
                    component: () => import('./views/business/dataCount/dataCount.vue'),
                    children:[
                        {
                            path: '/business/dataCount/customerCount',
                            name: '客服服务统计',
                            props:{index:"1-1"},
                            component: () => import('./views/business/dataCount/customerCount.vue'),
                        },
                        {
                            path: '/business/dataCount/searchCount',
                            name: '搜索记录统计',
                            props:{index:"1-2"},
                            component: () => import('./views/business/dataCount/searchCount.vue'),
                        },
                    ]
                },
                {
                    path: '/business/helpDoc',
                    name: '帮助文档',
                    props:{index:6},
                    component: () => import('./views/business/helpDoc/helpDoc.vue'),
                    children:[
                        {
                            path: '/business/helpDoc/qa',
                            name: '常见问题解决方案',
                            props:{index:"1-1"},
                            component: () => import('./views/business/helpDoc/qa.vue'),
                        },
                        {
                            path: '/business/helpDoc/doc',
                            name: '用户帮助文档',
                            props:{index:"1-2"},
                            component: () => import('./views/business/helpDoc/doc.vue'),
                        },
                        {
                            path: '/business/helpDoc/sentence',
                            name:'公共常用语',
                            props:{index:'1-3'},
                            component: () => import('./views/business/helpDoc/sentence.vue'),
                        }
                    ]
                },
                {
                    path:'/business/repairManagement',
                    name: '检修管理',
                    props:{index:7},
                    component: () => import('./views/business/repairManagement/repairManagement.vue'),
                    children:[
                        {
                            path:'/business/repairManagement/repairRecords',
                            name: '检修订单',
                            props:{index:"1-1"},
                            component: () => import('./views/business/repairManagement/repairRecords.vue')
                        },
                        {
                            path: '/business/repairManagement/repairRecordDetail',
                            name: '检修订单',
                            props: {index: "1-1"},
                            component: () => import('./views/business/repairManagement/repairRecordDetail.vue'),
                        },
                        {
                            path: '/business/repairManagement/orderAfter',
                            name: '订单售后',
                            props: {index: "1-2"},
                            component: () => import('./views/business/repairManagement/orderAfter.vue'),
                        },
                        {
                            path: '/business/repairManagement/refuseHandle',
                            name: '婉拒处理',
                            props: {index: "1-3"},
                            component: () => import('./views/business/repairManagement/refuseHandle.vue'),
                        },
                    ]
                },
                {
                    path: '/shareInventory',
                    name: '商城管理',
                    props:{index:8},
                    component: () => import('./views/business/shareInventory/shareInventory.vue'),
                    children: [
                        {
                            path: '/shareInventory/siOrderslist',
                            name: '现货订单',
                            props:{index:'1-1'},
                            component: () => import('./views/business/shareInventory/siOrdersList.vue')
                        },
                        {
                            path: '/shareInventory/siGoodsList',
                            name: '共享审核',
                            props:{index:'1-2'},
                            component: () => import('./views/business/shareInventory/siGoodsList.vue')
                        }                       
                    ]
                }
            ]
        },
        {
            path: '/noPermission',
            name: 'noPermission',
            props:{index:1},
            component: () => import('./views/noPermission.vue')
        },
        {
            path: '*',
            name: 'errorPage',
            props:{index:1},
            component: () => import('./views/404.vue')
        },
    ]
})
